import { interpolateSinebow } from "d3-scale-chromatic";

export type LatLng = [number, number];

export function midpoint(coords: LatLng[]): LatLng {
	return coords[Math.floor(coords.length / 2)];
}

export type Directions = {
	from: LatLng;
	to: LatLng;
	fromLabel: string;
	toLabel: string;
};

export const colors = [
	// "#e41a1c",
	"#377eb8",
	"#4daf4a",
	"#984ea3",
	// "#ff7f00",
	"#ffff33",
	"#a65628",
	"#f781bf",
];

const map = new Map();

let inc = -1;

export function color(dir: Directions): string {
	const key = [dir.from, dir.to].toString();
	let c = map.get(key);
	if (!c) {
		const anglePct =
			(Math.atan2(dir.to[1] - dir.from[1], dir.to[0] - dir.from[0]) * 180) /
			Math.PI /
			360;
		// console.warn("anglePct", anglePct);
		const diff = Math.max(
			Math.abs(dir.from[0] - dir.to[0]),
			Math.abs(dir.from[1] - dir.from[1])
		).toString();
		const diffPct = parseInt(diff[diff.length - 1]) / 10;
		inc = inc + 1;
		// console.warn("diffPct", diffPct, diff);
		// console.warn("Math.abs(anglePct - diffPct)", Math.abs(anglePct - diffPct));
		// console.warn(
		// 	"diff[diff.length - 1]  + diff[diff.length - 2]",
		// 	diff[diff.length - 1] + "" + diff[diff.length - 2]
		// );
		c = interpolateSinebow(
			parseInt(diff[diff.length - 1] + "" + diff[diff.length - 2]) / 100
		);
		map.set(key, c);
	}
	return c;
}

export function isEqual(dir1: Directions, dir2: Directions): boolean {
	return (
		dir1.from[0] === dir2.from[0] &&
		dir1.from[1] === dir2.from[1] &&
		dir1.to[0] === dir2.to[0] &&
		dir1.to[1] === dir2.to[1]
	);
}

export type AvoidedWay = {
	polyline: string;
	id: number;
};
